import { useEffect, useRef } from 'react';

import styles from './styles.module.scss';

export interface DialogModalProps {
  isOpen: boolean;
  onCancel: () => void;
  children: React.ReactNode;
  ariaLabelledById: string;
}

const DialogModal: React.FC<DialogModalProps> = ({ isOpen, children, onCancel, ariaLabelledById }) => {
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) {
      return;
    }

    if (isOpen && !dialog.open) {
      dialog.showModal();
    } else if (!isOpen && dialog.open) {
      dialog.close();
    }
  }, [isOpen]);

  const handleCancel = (e: React.SyntheticEvent): void => {
    e.preventDefault();
    onCancel();
  };

  return (
    <dialog ref={dialogRef} className={styles.dialogmodal} onCancel={handleCancel} aria-labelledby={ariaLabelledById}>
      <div className={styles['dialogmodal__content']}>{children}</div>
    </dialog>
  );
};

export default DialogModal;
